export default "__VITE_ASSET__B7iYc5qT__"